import Component from '../../shared/component';

export default class FacebookSender extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.FacebookSender', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.FacebookSender', this.handleClick);
  }

  handleClick() {
    if (!window.FB) return;

    window.FB.ui({
      method: 'send',
      link: this.$element.data('href'),
    });
  }
}
